// extracted by mini-css-extract-plugin
export default {"container":"projects_container__zGIN7"};